<!--
Copyright (c) 2020 GanttProject Cloud OU.
Author: Dmitry Barashev (dbarashev@ganttproject.cloud)
-->
<template>
    <div class="modal fade" id="modal-new-team" tabindex="-1" role="dialog" aria-labelledby="modal-new-team-title" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content" @keydown="newTeamApplyShortcut">
                <div class="modal-header">
                    <h5 class="modal-title" id="modal-new-team-title">New Team</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <div class="form-group">
                            <label for="modal-new-team-name">Name</label>
                            <input type="text" class="form-control" id="modal-new-team-name" placeholder="Team name"
                                   v-model="newTeamName">
                        </div>
                        <div class="form-group">
                            <label for="modal-new-team-desc">Description</label>
                            <textarea class="form-control" id="modal-new-team-desc" rows="3"
                                      v-model="newTeamDesc"></textarea>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <BtnSubmit title="Create Team" spinner ref="submitButton" :submitHandler="createTeam">
                    </BtnSubmit>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-facing-decorator';
import {handleXhrError, ShortcutHandler} from '../utils/Ui';
import {TeamCreate} from '../Routes';
import {TeamDto} from '../Teams';
import BtnSubmit from './BtnSubmit.vue';

import $ from 'jquery';

@Component({
    components: {BtnSubmit},
})
export default class TeamNewModal extends Vue {

  @Prop()
  public dashboardRefresh: (team: TeamDto) => void;
  private newTeamDesc: string = '';
  private newTeamName = '';
  private shortcutHandler = new ShortcutHandler();

  public mounted() {
    this.shortcutHandler.register('Enter', this.createTeam);
    $('#modal-new-team').on('shown.bs.modal', () => $('#modal-new-team-name').trigger('focus'));
  }

  private createTeam(): JQueryPromise<any> {
    return TeamCreate.invoke({
      name: this.newTeamName,
      description: this.newTeamDesc,
    }).then((newTeam: TeamDto) => {
      this.hide();
      this.dashboardRefresh(newTeam);
    }).fail((jqXhr) => {
      handleXhrError(jqXhr, 'Failed to create a new team');
    });
  }

  private newTeamApplyShortcut(e: KeyboardEvent) {
    this.shortcutHandler.handle(e);
  }

  private hide() {
    $('#modal-new-team').modal('hide');
    this.newTeamName = '';
    this.newTeamDesc = '';
  }
}
</script>

